import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import TechBox from './techBox';
import GuoxueBox from './guoxueBox';

class TGNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { techData, guoxueData, techAndGuoxueAd0, techAndGuoxueAd1 },
        } = this.props;

        return (
            <div className={styles.box}>
                <div className="clearfix">
                    <TechBox content={techData} />
                    <GuoxueBox content={guoxueData} />
                </div>
                <div className={styles.ad_box}>
                    {techAndGuoxueAd0 ? <Ad content={techAndGuoxueAd0} styleName={styles.fl} /> : ''}
                    {techAndGuoxueAd1 ? <Ad content={techAndGuoxueAd1} styleName={styles.fr} /> : ''}
                </div>
            </div>
        );
    }
}

export default errorBoundary(TGNews);
